
import { Component, Prop, mixins } from 'nuxt-property-decorator'

import { processSingleMetadata } from '@/utils/cachingStrategy'
import AuthMixin from '@/utils/mixins/authMixin'

import { getMimeType } from '@/utils/gallery/media'
import { getSanitizer, sanitizeIpfsUrl } from '@/utils/ipfs'
import { NFTMetadata } from '@/components/rmrk/service/scheme'
import { usePreferencesStore } from '@/stores/preferences'
import { NeoIcon } from '@kodadot1/brick'
const components = {
  LinkResolver: () => import('@/components/shared/LinkResolver.vue'),
  CommonTokenMoney: () => import('@/components/shared/CommonTokenMoney.vue'),
  BasicImage: () => import('@/components/shared/view/BasicImage.vue'),
  PreviewMediaResolver: () =>
    import('@/components/media/PreviewMediaResolver.vue'),
  NeoIcon,
}

@Component({ components })
export default class GalleryCard extends mixins(AuthMixin) {
  @Prop({ type: String, default: '/rmrk/gallery' })
  public route!: string
  @Prop({ type: String, default: 'rmrk/gallery' })
  public link!: string
  @Prop(String) public id!: string
  @Prop(String) public name!: string
  @Prop([String, Number]) public emoteCount!: string | number
  @Prop(String) public imageType!: string
  @Prop(String) public price!: string
  @Prop(String) public metadata!: string
  @Prop(String) public currentOwner!: string
  @Prop(Boolean) public listed!: boolean
  @Prop(Boolean) public hideName!: boolean
  public image = ''
  public title = ''
  public animatedUrl = ''
  public mimeType = ''
  private preferencesStore = usePreferencesStore()

  async fetch() {
    if (this.metadata) {
      const meta = await processSingleMetadata<NFTMetadata>(this.metadata)

      this.image = getSanitizer(meta.image || '', 'image')(meta.image || '')
      this.title = meta.name
      this.animatedUrl = sanitizeIpfsUrl(
        meta.animation_url || meta.mediaUri || '',
        'image'
      )
      this.mimeType = (await getMimeType(this.animatedUrl || this.image)) || ''
    }
  }

  get isBasicImage() {
    return !this.animatedUrl || (this.image && this.mimeType.includes('audio'))
  }

  get showPriceValue(): boolean {
    return this.listed || this.preferencesStore.getShowPriceValue
  }

  get nftName(): string {
    return this.name || this.title || '--'
  }

  get largeDisplay(): boolean {
    return (
      this.preferencesStore.getLayoutClass === 'is-half-desktop is-half-tablet'
    )
  }
}
